import React from "react";
import { Box, Typography } from "@material-ui/core";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import useCommonStyles from "./style";

// Indriya is assessed per organ; each resolves to one dosha (or none). `short`
// is used to build the saved label, e.g. "Vāta Netra".
export const INDRIYA_ORGANS = [
  { key: "netra", label: "Netra (Eyes)", short: "Netra", icon: "👁️" },
  { key: "shrotra", label: "Shrotra (Ears)", short: "Shrotra", icon: "👂" },
  { key: "ghrana", label: "Ghrana (Nose)", short: "Ghrana", icon: "👃" },
  { key: "jihva", label: "Jihva (Tongue)", short: "Jihva", icon: "👅" },
  { key: "tvak", label: "Tvak (Skin)", short: "Tvak", icon: "✋" },
];

export const INDRIYA_DOSHAS = ["Vāta", "Pitta", "Kapha"];

/**
 * Per-organ dropdowns for the Indriya (sensory organs) module. `values` maps each
 * organ key to a selected dosha ("" = not assessed); `onChange(organ, dosha)`.
 */
const IndriyaParameters = ({ values = {}, onOpenModule }) => {
  const classes = useCommonStyles();

  return (
    <Box mt={3}>
      <Typography
        className={`${classes.hiParamLabel} ${
          onOpenModule ? classes.hiParamLabelClickable : ""
        }`}
        style={{ fontWeight: 700, marginBottom: 10 }}
        title={onOpenModule ? "View / edit questions" : undefined}
        onClick={
          onOpenModule
            ? () =>
                onOpenModule({
                  moduleId: "indriya",
                  label: "Indriya (Sense Organs)",
                })
            : undefined
        }
      >
        Indriya (Sense Organs)
      </Typography>
      <Box className={classes.hiParamGrid}>
        {INDRIYA_ORGANS.map((organ) => {
          const selected = values[organ.key];
          return (
            <Box
              key={organ.key}
              className={`${classes.hiParamRow} ${
                selected ? classes.hiParamRowActive : ""
              }`}
            >
              <span className={classes.hiParamIcon}>
                {selected ? (
                  <CheckCircleRoundedIcon className={classes.hiParamCheck} />
                ) : (
                  organ.icon
                )}
              </span>
              <Typography
                className={`${classes.hiParamLabel} ${
                  selected ? classes.hiParamLabelActive : ""
                }`}
              >
                {organ.label}
              </Typography>
              <Typography
                className={
                  selected ? classes.hiParamValue : classes.hiParamValueEmpty
                }
              >
                {selected || "Not assessed"}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default IndriyaParameters;
